let state = {
  PaginaOficial_RutaParaElVisor: null,
  RutaDeArchivoADescargar:null
};

let getters = {
  Get_PaginaOficial_RutaParaElVisor: state => {
      return state.PaginaOficial_RutaParaElVisor;
  },
  Get_RutaDeArchivoADescargar: state => {
    return state.RutaDeArchivoADescargar;
}
}

let mutations = {
  M_PaginaOficial_EstableceLaRutaParaElVisor(state, data) {
    state.PaginaOficial_RutaParaElVisor = data;
},
M_RutaDeArchivoADescargar(state, data) {
  state.RutaDeArchivoADescargar = data;
}
};

let actions = {
  A_PaginaOficial_EstableceLaRutaParaElVisor: ({ commit }, data) => {
    commit('M_PaginaOficial_EstableceLaRutaParaElVisor', data);
  },
  A_RutaDeArchivoADescargar: ({ commit }, data) => {
    commit('M_RutaDeArchivoADescargar', data);
  }  
};

const PaginaOficial = {
  State: state,
  Getters: getters,
  Mutations: mutations,
  Actions: actions
};

export default PaginaOficial;



// WEBPACK FOOTER //
// ./src/store/PaginaOficial.js